import { render, staticRenderFns } from "./publishTEMU.vue?vue&type=template&id=5c4ecb6a&"
import script from "./publishTEMU.vue?vue&type=script&lang=js&"
export * from "./publishTEMU.vue?vue&type=script&lang=js&"
import style0 from "./publishTEMU.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports